export default __webpack_public_path__ + "locales/ar-SA/Ldap.json?hash=3123dbce6fd6d23a0e34ca783765069a";